import { useEffect, useState, useSyncExternalStore } from 'react';

import { Button } from '@/design-system';
import type { RefusedPhoto } from '@/entities/photo';

import { surveyCopy } from '../copy';
import {
    claimNoticeHost,
    dismissRefusedPhotos,
    isNoticeHost,
    refusedPhotos,
    subscribeToPhotoIntake,
} from './photo-intake';

function messageFor(problem: RefusedPhoto): string {
    return surveyCopy.question.photoRefused[problem.reason](problem.fileName);
}

/**
 * Wat er niet is toegevoegd, en waarom - in gewone taal, met wat de inspecteur
 * eraan doet. Amber, geen dialoog: de opname gaat gewoon door en de andere
 * foto's van dezelfde selectie staan er al.
 */
export function PhotoNotice() {
    const problems = useSyncExternalStore(subscribeToPhotoIntake, refusedPhotos, refusedPhotos);
    const host = useNoticeHost();

    if (!host || problems.length === 0) {
        return null;
    }

    return (
        <div
            role="status"
            aria-label={surveyCopy.question.photoNotAdded(problems.length)}
            className="fixed inset-x-3 bottom-3 z-[60] mx-auto flex max-w-[520px] flex-wrap items-start justify-between gap-3 rounded-[9px] border border-[var(--warn-border)] bg-[var(--warn-tint)] px-3 py-[11px] shadow-[var(--shadow-popover)]"
        >
            <div className="min-w-0 flex-1">
                <p className="m-0 text-[13px] leading-[1.4] font-medium text-[var(--warn-text)]">
                    {surveyCopy.question.photoNotAdded(problems.length)}
                </p>
                <ul className="m-0 mt-1 list-none p-0">
                    {problems.map((problem) => (
                        <li
                            key={`${problem.fileName}:${problem.reason}`}
                            className="text-[13px] leading-[1.5] text-[var(--text-primary)]"
                        >
                            {messageFor(problem)}
                        </li>
                    ))}
                </ul>
            </div>
            <Button variant="outline" size="md" onClick={dismissRefusedPhotos}>
                {surveyCopy.question.photoNoticeClose}
            </Button>
        </div>
    );
}

/** Eén melding op het scherm, ook al staat er onder elke vraag een fotoknop. */
function useNoticeHost(): boolean {
    const [token] = useState<object>(() => ({}));

    useEffect(() => claimNoticeHost(token), [token]);

    return useSyncExternalStore(
        subscribeToPhotoIntake,
        () => isNoticeHost(token),
        () => false,
    );
}
